import { ReactNode } from 'react';
import { Card, Space, Tag, Typography } from 'antd';
import { space } from '@viq-admin/ui';
import { NOT_ENABLED_COPY } from './copy';

export interface ProviderCardProps {
  title: string;
  /** Status Tag: green "Connected" / default "Not connected". Ignored when `enabled` is false. */
  connected?: boolean;
  /**
   * The company's entitlement to THIS provider. False renders the card muted
   * with a "Not enabled" tag; whatever `actions` the page hands in still
   * render (the page decides that Disconnect is the only one that belongs).
   * Required, with no default: the page always decides it, so a card is never
   * live by omission.
   */
  enabled: boolean;
  description: ReactNode;
  /** Right-of-description action row (Connect, or Test + Disconnect). */
  actions?: ReactNode;
}

/**
 * One CRM provider tile on the Integrations page (Salesforce / HubSpot /
 * Zoho). Pure presentation — connection state, the OAuth kickoff, and the
 * Test/Disconnect wiring all live in IntegrationsPage; this component only
 * renders whatever it's handed.
 */
export function ProviderCard({
  title,
  connected,
  enabled,
  description,
  actions,
}: ProviderCardProps) {
  return (
    <Card
      title={title}
      extra={
        enabled ? (
          <Tag color={connected ? 'green' : 'default'}>
            {connected ? 'Connected' : 'Not connected'}
          </Tag>
        ) : (
          <Tag>{NOT_ENABLED_COPY.tag}</Tag>
        )
      }
      style={enabled ? undefined : { opacity: 0.6 }}
    >
      <Space direction="vertical" size={space.sm} style={{ width: '100%' }}>
        <Typography.Text type="secondary">{description}</Typography.Text>
        {actions}
      </Space>
    </Card>
  );
}
